<template>
  <form class="form-signup" @submit.prevent="signup">
    <p v-if="errorMessage" class="text-danger">{{ errorMessage }}</p>
    <label for="display-name" class="sr-only">Display name</label>
    <input type="text" id="display-name" name="displayName" class="form-control" placeholder="Display name" required autofocus v-model.trim="displayName" />
    <label for="signup-email" class="sr-only">Email address</label>
    <input type="email" id="signup-email" name="email" class="form-control" placeholder="Email address" required v-model.trim="email" />
    <label for="signup-password" class="sr-only">Password</label>
    <input type="password" id="signup-password" name="password" class="form-control" placeholder="Password" required v-model="password" />
    <button type="submit" class="btn btn-lg btn-primary btn-block" :disabled="submitting">
      {{ submitting ? "Creating account..." : "Create account" }}
    </button>
  </form>
</template>

<script>
import { generateErrorMessage } from "../utilities/utilities";

export default {
  name: "SignUpForm",
  props: { inviteToken: { type: String, required: true } },
  data() {
    return {
      displayName: "",
      email: "",
      password: "",
      errorMessage: "",
      submitting: false,
    };
  },
  methods: {
    signup() {
      this.errorMessage = "";

      if (!this.displayName || !this.email || !this.password) {
        this.errorMessage = "Please complete all required fields";
        return;
      }

      this.submitting = true;
      this.$store
        .dispatch("signup", {
          displayName: this.displayName,
          inviteToken: this.inviteToken,
          email: this.email,
          password: this.password,
        })
        .then((membership) => {
          this.$router.replace({ name: "List", params: { id: membership.listId } });
        })
        .catch((error) => {
          this.errorMessage = (error.response && error.response.data.message) || generateErrorMessage(error);
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>

<style scoped>
.form-signup {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}

.form-signup .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
  margin-bottom: -1px;
  border-radius: 0;
}

.form-signup .form-control:focus {
  z-index: 2;
}

.form-signup input[type="password"] {
  margin-bottom: 10px;
}
</style>
